<template>
  <trac-modal top="!pt-0" size="max-w-xl modal-right" @close="$emit('close')">
    <div>
      <h3 class="text-lg font-medium leading-6 text-gray-900">
        Transaction Details
        <p class="text-sm text-gray-600">{{ log.payment_reference }}</p>
      </h3>

      <div class="my-4">
        <div
          class="py-3 flex flex-col gap-2"
          style="border-bottom: 1px solid #ccc; border-top: 1px solid #ccc"
        >
          <h4 class="font-bold uppercase text-center sm:text-left">
            Core Identifiers
          </h4>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Payment Reference:</p>
            <p>{{ log.payment_reference }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Payment Received:</p>
            <p>
              {{ moment(log.created_at).format("DD MMM YYYY - h:mm:ss a") }}
            </p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Last Updated:</p>
            <p>
              {{
                moment(log.updated_at).format("DD MMM YYYY - h:mm:ss a") ||
                "N/A"
              }}
            </p>
          </div>
        </div>

        <div
          class="py-3 flex flex-col gap-2"
          style="border-bottom: 1px solid #ccc"
        >
          <h4 class="font-bold uppercase text-center sm:text-left">
            Merchant & Store Context
          </h4>

          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Business Name:</p>
            <p>{{ log.business_name }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Business ID:</p>
            <p>{{ log.business_id }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Store ID:</p>
            <p>{{ log.store_id }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Omnipay ID:</p>
            <p>{{ log.omnipay_id || "N/A" }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Parent Aggregator:</p>
            <p>{{ log.parent_aggregator_name || "N/A" }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Settlement Type:</p>
            <p class="capitalize">{{ log.settlement_type || "N/A" }}</p>
          </div>
        </div>

        <div
          class="py-3 flex flex-col gap-2"
          style="border-bottom: 1px solid #ccc"
        >
          <h4 class="font-bold uppercase text-center sm:text-left">
            Payment Details
          </h4>

          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Payment Channel:</p>
            <p>{{ log.payment_channel }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Payment Method:</p>
            <p>{{ log.payment_method }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Acquirer Bank:</p>
            <p>{{ log.acquirer_bank }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Transaction Amount:</p>
            <p>{{ log.amount_paid | formatPrice(false) }}</p>
          </div>
        </div>

        <div
          class="py-3 flex flex-col gap-2"
          style="border-bottom: 1px solid #ccc"
        >
          <h4 class="font-bold uppercase text-center sm:text-left">
            Merchant Pricing
          </h4>

          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Pricing Band:</p>
            <p>{{ log.pricing_group }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Transaction Fee (MSC):</p>
            <p>{{ log.transaction_fee | formatPrice(false) }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Transaction Fee VAT:</p>
            <p>{{ log.transaction_fee_vat | formatPrice(false) }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>VAT Mode:</p>
            <p class="capitalize">{{ log.vat_type || "N/A" }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Stamp Duty:</p>
            <p>{{ log.stamp_duty | formatPrice(false) }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Loan Repayment:</p>
            <p>{{ log.loan_deduction | formatPrice(false) }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Savings Deduction:</p>
            <p>{{ log.saving_deduction | formatPrice(false) }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Lease-To-Own Deduction:</p>
            <p>{{ log.lease_to_own | formatPrice(false) }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Net Due Merchant:</p>
            <p>{{ log.net_fee_due_merchant | formatPrice(false) }}</p>
          </div>
        </div>

        <div
          v-if="
            log.sender_account_number && log.sender_account_number !== 'N/A'
          "
          class="py-3 flex flex-col gap-2"
          style="border-bottom: 1px solid #ccc"
        >
          <h4 class="font-bold uppercase text-center sm:text-left">
            Bank Transfer Details
          </h4>

          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Sender Bank:</p>
            <p>{{ log.sender_bank_name || "N/A" }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Sender Account Name:</p>
            <p>{{ log.sender_name || "N/A" }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Sender Account Number:</p>
            <p>{{ log.sender_account_number || "N/A" }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Receiving Account Number:</p>
            <p>{{ log.receiver_account_number || "N/A" }}</p>
          </div>
        </div>

        <div
          class="py-3 flex flex-col gap-2"
          style="border-bottom: 1px solid #ccc"
        >
          <h4 class="font-bold uppercase text-center sm:text-left">
            Settlement & Risk Status
          </h4>

          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Wallet Credited:</p>
            <p>{{ log.is_wallet_credited ? "Yes" : "No" }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Sent for Settlement:</p>
            <p>{{ log.is_settlement_notified ? "Yes" : "No" }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Fraud Status:</p>
            <p>{{ log.fraud_status ? "Yes" : "No" }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Transaction Flagged:</p>
            <p>{{ log.is_transaction_flagged ? "Yes" : "No" }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Resolution Status:</p>
            <p class="capitalize">{{ log.resolution_status || "N/A" }}</p>
          </div>
          <div
            class="flex sm:flex-row flex-col sm:justify-between items-center text-sm"
          >
            <p>Sale ID:</p>
            <p>{{ log.sale_id }}</p>
          </div>
        </div>
      </div>

      <button
        @click="$emit('close')"
        class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
      >
        Close
      </button>
    </div>
  </trac-modal>
</template>

<script>
import TracModal from "./general-components/Modal";
import moment from "moment";

export default {
  name: "ViewPaymentModal",
  emits: ["close"],
  components: {
    TracModal,
  },
  props: {
    log: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      moment,
    };
  },
  created() {
    console.log(this.log);
  },
};
</script>

<style>
.modal-right {
  margin-top: 0;
  border-radius: 0;
  margin-right: 0;
  /* mt-0! !ml-auto !mr-none rounded-none */
}
</style>
